import {Pipe, PipeTransform} from "@angular/core";
import {HuntGroupStrategy} from "../../model/huntGroupStrategy";

@Pipe({name: 'strategy'})
export class StrategyPipe implements PipeTransform {
    transform(value: any) {
        return HuntGroupStrategy[value];
    }
}
